import React, { useContext } from "react";
import { PreferredLanguageContext } from "../lib/main-context";
import NewFeatureDemos from "./NewFeatureDemos";
import juneNewsletterPdf from "../constants/juneNewsletter.pdf";
import Accordion from "./StyledComponents/Accordian";
import ComponentWrapper from "./DashboardComponents/ComponentWrapper";
import { Container } from "react-bootstrap";
import { useHistory, Link } from "react-router-dom";
import PillButton from "./StyledComponents/PillButton";
import { useTranslation } from "../i18n/TranslationProvider";

// images
import dayTrackingImg from "./../images/resourcesDayTracking.png";
import symptomsImg from "./../images/resourcesSymptom.png";
import symptomTrackingImg from "./../images/resourcesSymptomTracking.png";
import exerciseImg from "./../images/resourcesExcercises.png";
import messageBtnTmg from "./../images/resourcesMessageButton.png";
import newMessageBtnImg from "./../images/resourcesNewMessageBtn.png";
import messageReceivedImg from "./../images/resourcesMessageReceived.png";
import messagingImg from "./../images/resourcesMessaging.png";

const ResourcesPatientCaregiver = () => {
    const { t } = useTranslation();   
    const history = useHistory();

    const accountHelpFAQs = [
        {
            title: t("resources.accountHelp.faq1.title"),
            content: (
                <p>
                    {t("resources.accountHelp.faq1.content").split("submit a help ticket")[0]}
                    <Link to="/help">{t("resources.help.submitLink")}</Link>
                    {t("resources.accountHelp.faq1.content").split("submit a help ticket")[1]}
                </p>
            )
        },
        {
            title: t("resources.accountHelp.faq2.title"),
            content: (
                <p>
                    {t("resources.accountHelp.faq2.content").split("submit a help ticket")[0]}
                    <Link to="/help">{t("resources.help.submitLink")}</Link>
                    {t("resources.accountHelp.faq2.content").split("submit a help ticket")[1]}
                </p>
            )
        },
        {
            title: t("resources.accountHelp.faq3.title"),
            content: (
                <p>
                    {t("resources.accountHelp.faq3.content").split("submit a help ticket")[0]}
                    <Link to="/help">{t("resources.help.submitLink")}</Link>
                    {t("resources.accountHelp.faq3.content").split("submit a help ticket")[1]}
                </p>
            )
        }
    ];

    const providerFAQs = [
        {
            title: t("resources.providerAssignment.faq1.title"),
            content: (
                <p>
                    {t("resources.providerAssignment.faq1.content").split("submit a help ticket")[0]}
                    <Link to="/help">{t("resources.help.submitLink")}</Link>
                    {t("resources.providerAssignment.faq1.content").split("submit a help ticket")[1]}
                </p>
            )
        },
        {
            title: t("resources.providerAssignment.faq2.title"),
            content: (
                <p>
                    {t("resources.providerAssignment.faq2.content").split("submit a help ticket")[0]}
                    <Link to="/help">{t("resources.help.submitLink")}</Link>
                    {t("resources.providerAssignment.faq2.content").split("submit a help ticket")[1]}
                </p>
            )
        }
    ];

    const dashboardFAQs = [
        {
            title: t("resources.dashboard.faq1.title"),
            content: <p>{t("resources.dashboard.faq1.content")}</p>
        },
        {
            title: t("resources.dashboard.faq2.title"),
            content: (
                <div>
                    <p>{t("resources.dashboard.faq2.intro")}</p>
                    <ol>
                        <li>
                            <p>{t("resources.dashboard.faq2.item1")}</p>
                            <img src={dayTrackingImg} style={{ width: '50%', height: '50%', objectFit: 'contain' }} alt={t("resources.altText.dailyRatingScale")} />
                        </li>
                        <li>
                            <p>{t("resources.dashboard.faq2.item2")}</p>
                            <img src={symptomsImg} style={{ width: '40%', height: '40%', objectFit: 'contain' }} alt={t("resources.altText.symptomList")} />
                            <img src={symptomTrackingImg} style={{ width: '35%', height: '35%', objectFit: 'contain' }} alt={t("resources.altText.exampleSymptomTracking")} />
                        </li>
                    </ol>
                </div>
            )
        },
        {
            title: t("resources.dashboard.faq3.title"),
            content: <p>{t("resources.dashboard.faq3.content")}</p>
        },
        {
            title: t("resources.dashboard.faq4.title"),
            content: <p>{t("resources.dashboard.faq4.content")}</p>
        }   
    ];

    const exerciseFAQs = [
        {
            title: t("resources.exercise.faq1.title"),
            content: (
                <div>
                    <p>
                        {t("resources.exercise.faq1.content").split("Your Assigned Exercises")[0]}
                        <strong>{t("resources.exercise.yourAssignedExercises")}</strong>
                        {t("resources.exercise.faq1.content").split("Your Assigned Exercises")[1]}
                    </p>
                    <img src={exerciseImg} style={{ width: '30%', height: '30%', objectFit: 'contain' }} alt={t("resources.altText.exerciseSection")} />          
                </div>
            )
        },
        {
            title: t("resources.exercise.faq2.title"),
            content: <p>{t("resources.exercise.faq2.content")}</p>
        },
        {
            title: t("resources.exercise.faq3.title"),
            content: <p>{t("resources.exercise.faq3.content")}</p>
        },
        {
            title: t("resources.exercise.faq4.title"),
            content: <p>{t("resources.exercise.faq4.content")}</p>
        },
        {
            title: t("resources.exercise.faq5.title"),
            content: <p>{t("resources.exercise.faq5.content")}</p>
        }
    ];

    const messagingFAQs = [
        {
            title: t("resources.messaging.faq1.title"),
            content: (
                <div>
                    <p>{t("resources.messaging.faq1.step1")}</p>
                    <img src={messageBtnTmg} style={{ width: '20%', height: '20%', objectFit: 'contain' }} alt={t("resources.altText.redMessagesButton")} />
                    <p>{t("resources.messaging.faq1.step2")}</p>
                    <img src={messagingImg} style={{ width: '50%', height: '50%', objectFit: 'contain' }} alt={t("resources.altText.messagesPageScreenshot")} />
                </div>
            )
        },
        {
            title: t("resources.messaging.faq2.title"),
            content: (
                <div>
                    <p>{t("resources.messaging.faq2.step1")}</p>
                    <img src={newMessageBtnImg} style={{ width: '20%', height: '20%', objectFit: 'contain' }} alt={t("resources.altText.greenMessagesButton")} />
                    <p>{t("resources.messaging.faq2.step2")}</p>
                    <img src={messageReceivedImg} style={{ width: '50%', height: '50%', objectFit: 'contain' }} alt={t("resources.altText.newMessageScreenshot")} />
                </div>
            )
        },
        {
            title: t("resources.messaging.faq3.title"),
            content: (
                <p>
                    {t("resources.messaging.faq3.content").split("submit a help ticket")[0]}
                    <Link to="/help">{t("resources.help.submitLink")}</Link>
                    {t("resources.messaging.faq3.content").split("submit a help ticket")[1]}
                </p>
            )
        }
    ];

    return (
        <div>
            <h2>{t("dashboard.resources.title")}</h2>

            <section className="mt-4">
                <h4>{t("resources.accountHelp.title")}</h4>
                <div className="max-w-md border-gray-300 border ml-2 rounded p-3 shadow-sm">
                    {accountHelpFAQs.map(({ title, content }, index) => (
                        <Accordion key={index} title={title} content={content} />
                    ))}
                </div>
            </section>

            <section className="mt-4">
                <h4>{t("resources.providerAssignment.title")}</h4>
                <div className="border-gray-300 border ml-2 rounded p-3 shadow-sm">
                    {providerFAQs.map(({ title, content }, index) => (
                        <Accordion key={index} title={title} content={content} />
                    ))}
                </div>
            </section>

            <section className="mt-4">
                <h4>{t("resources.dashboard.title")}</h4>
                <div className="border-gray-300 border ml-2 rounded p-3 shadow-sm">
                    {dashboardFAQs.map(({ title, content }, index) => (
                        <Accordion key={index} title={title} content={content} />
                    ))}
                </div>
            </section>

            <section className="mt-4">
                <h4>{t("resources.exercise.title")}</h4>
                <div className="border-gray-300 border ml-2 rounded p-3 shadow-sm">
                    {exerciseFAQs.map(({ title, content }, index) => (
                        <Accordion key={index} title={title} content={content} />
                    ))}
                </div>
            </section>

            <section className="mt-4">
                <h4>{t("resources.messaging.title")}</h4>
                <div className="border-gray-300 border ml-2 rounded p-3 shadow-sm">
                    {messagingFAQs.map(({ title, content }, index) => (
                        <Accordion key={index} title={title} content={content} />
                    ))}
                </div>
            </section>

            <section className="mt-4">
                <h4>{t("resources.tutorials.title")}</h4>
                <table className="min-w-full border-collapse border rounded shadow-sm">
                    <thead> 
                        <tr className="bg-grey-500">
                            <th className="border px-4 py-2 text-left">{t("resources.tutorials.table.topic")}</th>
                            <th className="border px-4 py-2 text-left font-bold">{t("resources.tutorials.table.english")}</th>
                            <th className="border px-4 py-2 text-left font-bold">{t("resources.tutorials.table.spanish")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border px-4 py-2"><p><b>{t("resources.tutorials.table.caregiverRegistration")}</b></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/hwdx7rm60flrga0" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/hwdx7rm60flrga0</a></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/tqcepd5mu23gs4c" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/tqcepd5mu23gs4c</a></p></td>
                        </tr>
                        <tr>
                            <td className="border px-4 py-2"><p><b>{t("resources.tutorials.table.patientRegistration")}</b></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/4pk0hmsy4luzdob" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/4pk0hmsy4luzdob</a></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/xkywefm4j2n98vd" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/xkywefm4j2n98vd</a></p></td>
                        </tr>
                        <tr>
                            <td className="border px-4 py-2"><p><b>{t("resources.tutorials.table.caregiverDashboard")}</b></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/rrzv1tdza7oukqd" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/rrzv1tdza7oukqd</a></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/i8dioswrvssdh6q" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/i8dioswrvssdh6q</a></p></td>
                        </tr>
                        <tr>
                            <td className="border px-4 py-2"><p><b>{t("resources.tutorials.table.patientDashboard")}</b></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/fzz40eozc9dbgcb" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/fzz40eozc9dbgcb</a></p></td>
                            <td className="border px-4 py-2"><p><a href="https://canva.link/zl998gzqv1lu1zw" target="_blank" rel="noreferrer" className="text-teal-600 hover:underline">https://canva.link/zl998gzqv1lu1zw</a></p></td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <NewFeatureDemos />

            <section>
                <h4>{t("resources.help.title")}</h4>
                <p>{t("resources.help.content")}</p>
                <PillButton className="pillBtn" onClick={() => history.push("/help")}>
                    {t("resources.help.button")}
                </PillButton>
            </section>
        </div>
    );
};

export default ResourcesPatientCaregiver;